import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import ScrollSection from './components/layout/ScrollSection';
import Hero from './components/sections/Hero'; // Keep Hero eager-loaded for LCP
import Footer from './components/layout/Footer';
import './i18n'; // Initialize i18n

// Lazy-load non-critical, heavy sections to reduce initial bundle and main-thread work
const Technology = lazy(() => import('./components/sections/Technology'));
const Products = lazy(() => import('./components/sections/Products'));
const Research = lazy(() => import('./components/sections/Research'));
const Career = lazy(() => import('./components/sections/Career'));
const About = lazy(() => import('./components/sections/About'));
const Team = lazy(() => import('./components/sections/Team'));
const Partners = lazy(() => import('./components/sections/Partners'));
const Contact = lazy(() => import('./components/sections/Contact'));
const NotFound = lazy(() => import('./components/sections/NotFound'));
const Impressum = lazy(() => import('./components/sections/Impressum'));
const Univais = lazy(() => import('./components/sections/Univais'));
const UnivaisPrivacy = lazy(() => import('./components/sections/UnivaisPrivacy'));

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black">
        {/* Skip link for keyboard navigation */}
        <a 
          href="#main-content" 
          className="skip-link sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-primary-blue focus:text-white focus:px-4 focus:py-2 focus:rounded"
        >
          Skip to main content
        </a>
        <Header />

        <Routes>
          <Route path="/" element={
            <main id="main-content" className="pt-16" role="main">
              <ScrollSection 
                id="hero" 
                className=""
                animationVariant="fadeIn"
                animationConfig={{ duration: 0.8, easing: 'smooth', pauseDuration: 800 }}
              >
                <Hero />
              </ScrollSection>
              
              <ScrollSection 
                id="technology" 
                className=""
                animationVariant="fadeInUp"
                animationConfig={{ duration: 0.5, delay: 0.1, easing: 'easeOutBack', pauseDuration: 800 }}
              >
                <Suspense fallback={<div className="py-12"><div className="w-8 h-8 border-2 border-gray-600 border-t-blue-500 rounded-full animate-spin mx-auto" /></div>}>
                  <Technology />
                </Suspense>
              </ScrollSection>
              <div className="h-1 bg-gradient-to-r from-transparent via-gray-700 to-transparent my-8"></div>

              <ScrollSection 
                id="products" 
                className=""
                animationVariant="fadeInUp"
                animationConfig={{ duration: 0.5, delay: 0.1, easing: 'easeOutBack', pauseDuration: 800 }}
              >
                <Suspense fallback={<div className="py-12"><div className="w-8 h-8 border-2 border-gray-600 border-t-blue-500 rounded-full animate-spin mx-auto" /></div>}>
                  <Products />
                </Suspense>
              </ScrollSection>
              <div className="h-1 bg-gradient-to-r from-transparent via-gray-700 to-transparent my-8"></div>

              <ScrollSection 
                id="research" 
                className=""
                animationVariant="fadeInUp"
                animationConfig={{ duration: 0.5, delay: 0.1, easing: 'easeOutBack', pauseDuration: 800 }}
              >
                <Suspense fallback={<div className="py-12"><div className="w-8 h-8 border-2 border-gray-600 border-t-blue-500 rounded-full animate-spin mx-auto" /></div>}>
                  <Research />
                </Suspense>
              </ScrollSection>
              <div className="h-1 bg-gradient-to-r from-transparent via-gray-700 to-transparent my-8"></div>

              <ScrollSection 
                id="career" 
                className=""
                animationVariant="fadeInUp"
                animationConfig={{ duration: 0.5, delay: 0.1, easing: 'easeOutBack', pauseDuration: 800 }}
              >
                <Suspense fallback={<div className="py-12"><div className="w-8 h-8 border-2 border-gray-600 border-t-blue-500 rounded-full animate-spin mx-auto" /></div>}>
                  <Career />
                </Suspense>
              </ScrollSection>
              <div className="h-1 bg-gradient-to-r from-transparent via-gray-700 to-transparent my-8"></div>

              <ScrollSection 
                id="about" 
                className=""
                animationVariant="fadeInUp"
                animationConfig={{ duration: 0.5, delay: 0.1, easing: 'easeOutBack', pauseDuration: 800 }}
              >
                <Suspense fallback={<div className="py-12"><div className="w-8 h-8 border-2 border-gray-600 border-t-blue-500 rounded-full animate-spin mx-auto" /></div>}>
                  <About />
                </Suspense>
              </ScrollSection>
              <div className="h-1 bg-gradient-to-r from-transparent via-gray-700 to-transparent my-8"></div>

              <ScrollSection 
                id="team" 
                className=""
                animationVariant="fadeInUp"
                animationConfig={{ duration: 0.5, delay: 0.1, easing: 'easeOutBack', pauseDuration: 800 }}
              >
                <Suspense fallback={<div className="py-12"><div className="w-8 h-8 border-2 border-gray-600 border-t-blue-500 rounded-full animate-spin mx-auto" /></div>}>
                  <Team />
                </Suspense>
              </ScrollSection>
              <div className="h-1 bg-gradient-to-r from-transparent via-gray-700 to-transparent my-8"></div>

              <ScrollSection 
                id="partners" 
                className=""
                animationVariant="fadeInUp"
                animationConfig={{ duration: 0.5, delay: 0.1, easing: 'easeOutBack', pauseDuration: 800 }}
              >
                <Suspense fallback={<div className="py-12"><div className="w-8 h-8 border-2 border-gray-600 border-t-blue-500 rounded-full animate-spin mx-auto" /></div>}>
                  <Partners />
                </Suspense>
              </ScrollSection>
              <div className="h-1 bg-gradient-to-r from-transparent via-gray-700 to-transparent my-8"></div>



              <ScrollSection 
                id="contact" 
                className=""
                animationVariant="fadeInUp"
                animationConfig={{ duration: 0.5, delay: 0.1, easing: 'easeOutBack', pauseDuration: 800 }}
              >
                <Suspense fallback={<div className="py-12"><div className="w-8 h-8 border-2 border-gray-600 border-t-blue-500 rounded-full animate-spin mx-auto" /></div>}>
                  <Contact />
                </Suspense>
              </ScrollSection>
            </main>
          } />
          <Route path="/impressum" element={
            <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="w-8 h-8 border-2 border-gray-600 border-t-blue-500 rounded-full animate-spin" /></div>}>
              <Impressum />
            </Suspense>
          } />
          <Route path="/univais" element={
            <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="w-8 h-8 border-2 border-gray-600 border-t-blue-500 rounded-full animate-spin" /></div>}>
              <Univais />
            </Suspense>
          } />
          <Route path="/univais/datenschutz" element={
            <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="w-8 h-8 border-2 border-gray-600 border-t-blue-500 rounded-full animate-spin" /></div>}>
              <UnivaisPrivacy />
            </Suspense>
          } />
          <Route path="*" element={
            <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="w-8 h-8 border-2 border-gray-600 border-t-blue-500 rounded-full animate-spin" /></div>}>
              <NotFound />
            </Suspense>
          } />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;